import axios from 'axios';
import CryptoJS from 'crypto-js';
import VueElementLoading from 'vue-element-loading';
import {BasicSelect,MultiSelect} from 'vue-search-select';
import CreateSlab from './../createSlab';
import Pagination from './../../../../shared/components/pagination';
import CustomExpandableTable from '../../../../shared/components/customExpandableTable';
import MasterService from './../../../services/masterdata.service';
import Util from './../../../../shared/util/util';
import CONSTANT from './../../../../shared/constants/constant';

export default {
  name: 'slabtemplate',
  components: {
    VueElementLoading,
    Pagination,
    BasicSelect,
    CreateSlab,
    VueElementLoading,
    CustomExpandableTable
  },
  data: function() {
    return {
      slabName: '',
      type: 'SLAB_MASTER',
      isLoading:false,
      Loader:false,
      showlist: true,
      currentPage: 1,
      totalPage: 0,
      totalCount:0,
      offset:0,
      pageLimit:CONSTANT.PER_PAGE_DATA,
      tableArr:[],
      tableColumn: [ 'Slab Name', 'Slab Type', 'Slab Sub Type','#of Slab Breaks','Created By','Created Date','Last Modified By','Last Modified Date','Status', 'Action'],
      innerTableColumn: [],
      tableItems: [],
      SlabTypeObj:{
        '1':'Weight (kg)',
        '2':'Invoice Amount (INR)',
        '3':'Distance (km)',
        '4':'Quantity (Number of boxes)'
      },
      SlabSubTypeObj:{
        '1':'Billable',
        '2':'Physical',
        '3':'Volumetric'
      },
      selectedSlabObj:'',
      slabDetails:'',
      status:"",
      slabNameSearch:"",
      statusSearch:"",
      statuslist:[{
        value : "1",
        text : 'Active'
      },{
        value : "0",
        text : 'Inactive'
      }],
      statusitem:{value:'',text:''},
    }
  },
  computed: {

  },
  mounted() {
    this.getSlabListing();
  },
  methods: {
    selectedStatus(statusitem){
      this.statusitem = statusitem;
      this.status = this.statusitem.value;
    },
    showCreateSlab() {
      this.selectedSlabObj = [];
      this.showlist = false;
    },
    callParent() {
        this.showlist = true;
        this.selectedSlabObj = null;
        this.currentPage = 1;
        this.offset = 0;
        this.getSlabListing();
      },
    onPageChange(page) {
      this.currentPage = page;
      this.offset = (page - 1) *this.pageLimit
      this.getSlabListing();
    },
    async activeAction(data){
      try {
        this.isLoading = true;
        var item = this.tableArr.find(item => item.id === data.id);
        var isactivestatus = item.status == 0 ? 1 : 0
        let inputPayload = {
          "id": data.id,
          "type": this.type,
          "status": isactivestatus
        }
        let result = await MasterService.changeStatus(inputPayload)
        if(result.data.code == 200){
          if(result.data.data[0].status == 0){
          this.$alert("Slab  Activated Successfully!!", this.slabName, "success");
        }else{
          this.$alert("Slab Inactivated Successfully!!", this.slabName, "success");
         }
          this.getSlabListing();
          this.isLoading = false;
        }
      } catch(err){
        console.log(err);
      }
    },
    getCustomTableEvent(event){
      if(event.actionType=="active"){
        this.$confirm("Are you sure to make Active/Inactive?","","question").then(() => {
        this.activeAction(event);
       }).catch((err)=>{
         console.log(err)
       });
     }else if(event.actionType=="inactive"){
        this.$confirm("Are you sure to make Active/Inactive?","","question").then(() => {
        this.activeAction(event);
       }).catch((err)=>{
         console.log(err)
       })
      }
      if(event.actionType=="edit"){
        let selectedSlabObj  = this.tableArr.filter(function(Items) {
          return Items.id == event.id;
        });
        this.selectedSlabObj = selectedSlabObj[0];
        this.showlist = false;
      }else if(event.actionType=="view"){
        this.getSlabDetails(event.id);
      }
    },
    async getSlabDetails(slabid){
      try {
        let InputPayload = {
          slabid: slabid
        }
        this.isLoading = true;
        let response = await MasterService.getSlabDetails(InputPayload);
        let data = response.data.data;
        let slabsDataArr = [];
        let slabdata = data.slabbreakupdetails;
        slabdata.forEach(function (item) {
          slabsDataArr.push({
              selectedLowerLimit: item.lowerlimit,
              selectedHigherLimit: item.higherlimit,
              lowerlimitvalue: item.lowerlimitvalue,
              higherlimitvalue: item.higherlimitvalue,
            });
        });

        this.slabDetails = {
          'slabname':data.slabname,
          'slabdescription':data.slabdescription,
          'slabtype': this.SlabTypeObj[data.slabtype],
          'slabsubtype': this.SlabSubTypeObj[data.slabsubtype],
          'slabsData': slabsDataArr
        }
        this.isLoading = false;
      } catch(err){
        this.isLoading = false;
        console.log(err);
      }
    },
    getTypeLabel(type){
      if(type=="gt"){
        return "> (greater than)";
      }else if(type=="gte"){
        return ">= (greater than or equal to)";
      }else if(type=="lt"){
        return "< (less than)";
      }else if(type=="lte"){
        return "<= (less than or equal to)";
      }
    },
    searchSlab(){
      this.currentPage = 1;
      this.offset = 0;
      this.slabNameSearch = this.slabName;
      this.statusSearch = this.status;
      this.getSlabListing();
    },
    resetSlab(){
      this.currentPage = 1;
      this.slabName= "";
      this.slabNameSearch= "";
      this.status= "";
      this.statusSearch= "";
      this.statusitem = {};
      this.getSlabListing();
    },
    async getSlabListing(){
      try {
        this.isLoading = true;
        let inputPayload = {
          "offset": this.offset,
          "limit": this.pageLimit
        }
        if(this.slabNameSearch!=""){
          inputPayload.slabname = this.slabNameSearch;
        }
        if(this.statusSearch!=""){
          inputPayload.status = this.statusSearch;
        }

        let allResolved = await Promise.all([MasterService.getSlabListing(inputPayload)])
        let result = allResolved[0]
        this.tableArr = result.data.data.rows;
        this.isLoading = false;
        this.totalCount = result.data.data.count.length;
        if(this.totalCount>0){
          this.tableItems = result.data.data.rows.map((el)=>{
            return {
              'id':el.id,
              'Slab Name':el.slabname,
              'Slab Type': this.SlabTypeObj[el.slabtype],
              'Slab Sub Type': this.SlabSubTypeObj[el.slabsubtype],
              '#of Slab Breaks': el.slabbreak,
              'Created By':el.createdby,
              'Created Date':Util.displayDateTimeFormat(el.createddate),
              'Last Modified By':el.lastmodifiedby,
              'Last Modified Date':Util.displayDateTimeFormat(el.lastmodifieddate),
              'Status': el.status,
              'Action': 'Need To Check1'
            }
          })
        }else{
          this.tableItems = [];
        }
        if (this.totalCount < this.pageLimit) {
          this.totalPage = 1
        } else {
          this.totalPage = Math.ceil(this.totalCount / this.pageLimit);
        }
      } catch(err){
        console.log(err);
        this.isLoading = false;
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/modules/masterdata/views/Slabs/slabListing/slabListing.component.js